import { isMarketingAllowed } from './consent';

export const DATALAYER_ALLOWED_KEYS = new Set([
  'event',
  'video_id',
  'video_title',
  'video_url',
  'video_percent',
  'video_max_percent',
  'video_last_position',
  'video_duration',
  'video_completed',
  'video_cta_clicked',
  'video_cta_id',
  'video_cta_name',
  'video_cta_attribution',
  'vlt_visitor_id',
  'vlt_session_id',
  'vlt_cid',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'gclid',
  'fbclid',
  'yclid',
  'page_location',
  'referrer',
  'lead_id',
]);

export function pushDataLayer(payload: Record<string, unknown>): void {
  if (!isMarketingAllowed()) return;

  const filtered: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(payload)) {
    if (DATALAYER_ALLOWED_KEYS.has(key)) filtered[key] = value;
  }

  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push(filtered);
}
